import { HTTP as http } from '../http/axios'

export default {

    get: ( cnpj ) => {
        cnpj = cnpj.replace(/[^\d]+/g,'')
        return http.get('/consultaCnpj/'+cnpj)
    }

}
